import api from './api.service';

export interface EnrollmentFormConfig {
  id: string;
  userId: string | null;
  colocId: string | null;
  documentName: string;
  isMandatoryCandidate: boolean;
  isMandatoryGuarantor: boolean;
  comment: string | null;
  isDefault: boolean;
  category: string;
}

class EnrollmentConfigService {
  async getConfigsForUser(userId: string): Promise<EnrollmentFormConfig[]> {
    const response = await api.get(`/users/${userId}/enrollment-form-configs`);
    return response.data;
  }

  async getDefaults(): Promise<EnrollmentFormConfig[]> {
    const response = await api.get('/enrollment-form-configs/defaults');
    return response.data;
  }

  async createConfig(data: {
    document_name: string;
    is_mandatory_candidate: boolean;
    is_mandatory_guarantor: boolean;
    category: string;
    comment?: string;
  }): Promise<EnrollmentFormConfig> {
    const response = await api.post('/enrollment-form-configs', data);
    return response.data;
  }

  async updateConfig(id: string, data: {
    is_mandatory_candidate?: boolean;
    is_mandatory_guarantor?: boolean;
    category?: string;
    comment?: string;
  }): Promise<EnrollmentFormConfig> {
    const response = await api.put(`/enrollment-form-configs/${id}`, data);
    return response.data;
  }

  async deleteConfig(id: string): Promise<void> {
    await api.delete(`/enrollment-form-configs/${id}`);
  }
}

export const enrollmentConfigService = new EnrollmentConfigService();
